var map = {
	"./telia-accordion_2.entry.js": [
		7136,
		7136
	],
	"./telia-alert-badge.entry.js": [
		1792,
		1792
	],
	"./telia-badge_2.entry.js": [
		3169,
		3169
	],
	"./telia-banner-billboard.entry.js": [
		6806,
		6806
	],
	"./telia-breadcrumbs-item.entry.js": [
		4203,
		4203
	],
	"./telia-breadcrumbs.entry.js": [
		6136,
		6136
	],
	"./telia-button.entry.js": [
		9168,
		9168
	],
	"./telia-card-frame.entry.js": [
		8664,
		8664
	],
	"./telia-checkbox.entry.js": [
		6540,
		6540
	],
	"./telia-chip-choice.entry.js": [
		1210,
		1210
	],
	"./telia-chip-filter.entry.js": [
		9597,
		9597
	],
	"./telia-col_3.entry.js": [
		5276,
		5276
	],
	"./telia-color-dot.entry.js": [
		7317,
		7317
	],
	"./telia-content-banner.entry.js": [
		9110,
		9110
	],
	"./telia-counter-badge.entry.js": [
		5846,
		5846
	],
	"./telia-cta-link.entry.js": [
		1385,
		1385
	],
	"./telia-date-picker.entry.js": [
		1035,
		1035
	],
	"./telia-divider.entry.js": [
		3949,
		3949
	],
	"./telia-field-assistive-text_3.entry.js": [
		3892,
		3892
	],
	"./telia-field-valid.entry.js": [
		1995,
		1995
	],
	"./telia-fieldset.entry.js": [
		2291,
		2291
	],
	"./telia-focus-trap.entry.js": [
		2491,
		2491
	],
	"./telia-footer-legal.entry.js": [
		3275,
		3275
	],
	"./telia-footer-navigation.entry.js": [
		7889,
		7889
	],
	"./telia-footer-partners.entry.js": [
		6797,
		6797
	],
	"./telia-footer.entry.js": [
		753,
		753
	],
	"./telia-form.entry.js": [
		5262,
		5262
	],
	"./telia-heading.entry.js": [
		5366,
		5366
	],
	"./telia-hero-banner.entry.js": [
		4591,
		4591
	],
	"./telia-icon.entry.js": [
		3606,
		3606
	],
	"./telia-image.entry.js": [
		3192,
		9610
	],
	"./telia-link-image.entry.js": [
		7653,
		7653
	],
	"./telia-link_2.entry.js": [
		2540,
		2540
	],
	"./telia-list.entry.js": [
		4735,
		4735
	],
	"./telia-logo.entry.js": [
		6525,
		6525
	],
	"./telia-navigation-button.entry.js": [
		4103,
		4103
	],
	"./telia-navigation-dropdown.entry.js": [
		3732,
		3732
	],
	"./telia-navigation-link.entry.js": [
		6069,
		6069
	],
	"./telia-navigation.entry.js": [
		8984,
		8984
	],
	"./telia-notification.entry.js": [
		153,
		153
	],
	"./telia-overlay.entry.js": [
		8363,
		8363
	],
	"./telia-p.entry.js": [
		8013,
		8013
	],
	"./telia-pictogram.entry.js": [
		6148,
		6148
	],
	"./telia-price.entry.js": [
		1722,
		1722
	],
	"./telia-product-card-hardware.entry.js": [
		629,
		629
	],
	"./telia-radio-button.entry.js": [
		9209,
		9209
	],
	"./telia-search-input.entry.js": [
		2437,
		2437
	],
	"./telia-select.entry.js": [
		9001,
		9001
	],
	"./telia-skeleton.entry.js": [
		6298,
		6298
	],
	"./telia-slot-group.entry.js": [
		6659,
		6659
	],
	"./telia-status-badge.entry.js": [
		1010,
		1010
	],
	"./telia-style-navigation-item.entry.js": [
		9878,
		9878
	],
	"./telia-tab-content.entry.js": [
		2145,
		2145
	],
	"./telia-tab-header.entry.js": [
		4025,
		4025
	],
	"./telia-tab.entry.js": [
		1932,
		1932
	],
	"./telia-text-input.entry.js": [
		5938,
		5938
	],
	"./telia-text-spacing.entry.js": [
		5901,
		5901
	],
	"./telia-textarea.entry.js": [
		7610,
		7610
	],
	"./telia-toggle.entry.js": [
		2457,
		2457
	],
	"./telia-video-player.entry.js": [
		2483,
		2483
	],
	"./telia-visually-hidden.entry.js": [
		7069,
		7069
	],
	"./telia-voca-stats.entry.js": [
		555,
		555
	],
	"./telia-vst.entry.js": [
		4521,
		4521
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3951;
module.exports = webpackAsyncContext;